<template>
  <article class="card">
    <a @click.prevent="goToMenu()" :href="url" class="link">
      <div class="image-wrapper">
        <img
          class="image lozad"
          :data-src="$CDN + image.imageUrl"
          :alt="image.imageAlt"
          width="120"
          height="125"
        />
      </div>
      <div class="content">
        <h3 class="title">{{ name }}</h3>
        <ul class="category-list">
          <li class="category" v-for="(category, i) in categories" :key="i">
            {{ category }}<span v-if="i < categories.length - 1">, </span>
          </li>
        </ul>
        <div class="distance-from-address" v-if="distance">
          {{ distance }} Miles Away
        </div>
        <div v-if="!open" class="open-time">
          <icon-base
            width="12"
            height="12"
            class="wait-time-icon"
            :iconName="'Open Time'"
            :id="'openTimeCardSmall' + restId"
          >
            <icon-clock />
          </icon-base>
          <span>{{ getOpenTime(openTime) }}</span>
        </div>
      </div>
    </a>
  </article>
</template>

<script>
import IconBase from './IconBase.vue'
import IconClock from './icons/IconClock.vue'
var lozad = require('lozad')

export default {
  name: 'CardSmall',
  components: {
    IconBase,
    IconClock,
  },
  async mounted() {
    const observer = lozad()
    observer.observe()
  },
  props: {
    name: { type: String, required: true },
    restId: { type: [String, Number], required: true },
    waitTime: [String, Number],
    openTime: { type: [String, Number] },
    open: { type: Boolean, required: true },
    categories: {
      type: Array,
      defautl: () => [],
    },
    image: {
      type: Object,
      default: () => {},
    },
    url: {
      type: String,
      required: true,
    },
    hours: { type: Object, required: true },
    deliveryFee: { type: String },
    distance: { type: String },
  },
  methods: {
    goToMenu: function () {
      if (this.open) {
        window.location.href = this.url
        return false
      }
      this.$emit('showLaterOrderModal', {
        hours: this.hours,
        restName: this.name,
        url: this.url,
        restId: this.restId,
      })
      return false
    },
    getOpenTime: function (date) {
      if (!date || date === '000000') {
        return 'Currently unavailable'
      }
      if (date === 'closed today') {
        return 'Closed today'
      }
      var time = new Date()
      time.setHours(date.slice(0, 2))
      time.setMinutes(date.slice(2, 4))

      var hour = time.getHours()
      var minute = time.getMinutes()
      var timePeriod = hour >= 12 ? 'PM' : 'AM'
      if (hour > 12) {
        hour = hour - 12
      }
      if (minute === 0) {
        minute = minute + '0'
      }
      date = hour + ':' + minute + ' ' + timePeriod
      return 'Open at ' + date
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  @include card-wrapper;
  cursor: pointer;
}

.link {
  display: flex;
  width: 100%;
  text-decoration: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  font-size: inherit;
  cursor: pointer;
  color: inherit;
  font: inherit;
}
.link:focus {
  border: 2px solid #0184c6;
}

.image-wrapper {
  position: relative;
  min-height: 125px;
  flex: 0 0 120px;
}

.image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content {
  flex: 1 1 auto;
  padding: 7px;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.3;
  text-align: left;
}

.category {
  font-size: 1.3rem;
  display: inline;
}

.category-list {
  text-align: left;
}

.wait-time-icon {
  margin-right: 3px;
}

.wait-time {
  font-size: 1.1rem;
  font-weight: 700;
  color: $royal;
  margin-top: auto;
  display: flex;
  align-items: center;
  width: max-content;
}

.open-time {
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
  margin-top: auto;
  padding-left: 5px;
  padding-right: 5px;
  display: flex;
  align-items: center;
  background-color: $tomato;
  border: none;
  border-radius: 4px;
  max-width: fit-content;
}
</style>
